<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <div class="chat-container">
        <div class="chat-message-box">
          <div class="chat-messages-list" ref="messagesList">
            <div v-if="chats.length === 0" class="no-chats">No messages yet.</div>
            <div v-for="msg in chats" :key="msg._id" :class="['chat-message', msg.role === 'user' ? 'right' : 'left']">
              <div class="chat-message-content">
                <div class="chat-message-text">{{ msg.message }}</div>
                <div class="chat-message-date">{{ formatDate(msg.createdAt) }}</div>
              </div>
            </div>
            <div class="load-more-container" v-if="isMore">
              <vs-button size="small" @click="loadMore" :disabled="loadingMore" v-if="chats.length > 0">Load More</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";

export default {
  name: "ChatMessageBox",
  props: {
    chat: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    chats: [],
    page: 1,
    loadingMore: false,
    isMore: true,
  }),
  methods: {
    async fetchMessages({ append = false } = {}) {
      if (!append) this.$vs.loading();
      else this.loadingMore = true;
      try {
        const res = await api.get(`${API.AI_GET_MESSAGES_UID}?deviceId=${this.chat.deviceId}&userId=${this.chat.userId}&page=${this.page}`);
        if (res.status == 200) {
          const newMessages = res.data.data || [];
          if (append) {
            this.chats = [...this.chats, ...newMessages];
          } else {
            this.chats = newMessages;
          }
          this.isMore = res.data.isMore;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error fetching messages",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        if (!append) this.$vs.loading.close();
        else this.loadingMore = false;
      }
    },
    loadMore() {
      this.page += 1;
      this.fetchMessages({ append: true });
    },
    formatDate(dateStr) {
      const m = moment(dateStr);
      if (!m.isValid()) return "Invalid date";
      return m.format("MMM DD, YYYY HH:mm A");
    },
  },
  async created() {
    await this.fetchMessages();
  },
  watch: {
    chat: {
      handler() {
        this.page = 1;
        this.fetchMessages();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.chat-container {
  height: 100vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.chat-message-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  min-width: 0;
  height: 100%;
  overflow: hidden;
}
.load-more-container {
  display: flex;
  justify-content: center;
}
.chat-messages-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 12px;
}
.chat-message {
  display: flex;
  flex-direction: row;
  margin-bottom: 0px;
}
.chat-message.left {
  justify-content: flex-start;
}
.chat-message.right {
  justify-content: flex-end;
}
.chat-message-content {
  max-width: 60%;
  background: #f1f1f1;
  border-radius: 12px;
  padding: 10px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  word-break: break-word;
}
.chat-message.right .chat-message-content {
  background: #d1f5e0;
  align-items: flex-end;
}
.chat-message.left .chat-message-content {
  background: #f1f1f1;
  align-items: flex-start;
}
.chat-message-text {
  font-size: 15px;
  color: #222;
}
.chat-message-date {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
  text-align: right;
}
.no-chats {
  padding: 24px;
  text-align: center;
  color: #aaa;
}
</style>
